export default "__VITE_ASSET__CSvUPVZf__"